<template>
  <div class="debug-info">
    <ul class="debug-info-group" v-for="(info, key) in normalizeObject" :key="key">
      <li class="debug-info__key">
        {{ info[0] }} <span v-if="typeof info[1] != 'object'">: {{ info[1] }}</span>
      </li>
      <li v-if="typeof info[1] == 'object'">
        <ul class="debug-info__sub-list">
          <li v-for="(sub, k2) in info[1]" :key="k2"><strong>{{ sub[0] }}:</strong> {{ sub[1] }}</li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'debug-info',
    props: {
      // eslint-disable-next-line vue/require-default-prop
      infos: {
        type: Object,
      },
    },
    computed: {
      normalizeObject() {
        return Object.keys(this.infos).map((key) => {
          let innerArray = this.infos[key];
          if (typeof innerArray == 'object') {
            innerArray = Object.keys(this.infos[key]).map((secondKey) => {
              return [secondKey, this.infos[key][secondKey]];
            });
          }
          return [key, innerArray];
        });
      }
    }
  };
</script>

<style lang="scss">
  .debug-info {
    background-color: yellow;
    padding-left: 15px;
    position: fixed;
    top: 170px;
    left: 0;
    width: 200px;
    display: none;
    z-index: 3;

    &__key {
      font-weight: bold;
      white-space: nowrap;
    }

    &__sub-list {
      padding-left: 15px;
      white-space: nowrap;
      li {
        white-space: nowrap;
      }
    }
  }

  .article-card {
    &:hover {
      .debug-info {
        display: block;
      }
    }
  }
</style>
